"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const JavaScriptObfuscatorFacade_1 = require("./src/JavaScriptObfuscatorFacade");
module.exports = JavaScriptObfuscatorFacade_1.JavaScriptObfuscator;
